<template>
  <VFBLoginScope
    :app-id="facebookAppId"
    version="v19.0"
    @login="connectToFacebook"
    @sdk-init="$emit('facebook-working')"
  >
    <button
      id="facebook-connect-button"
      slot-scope="scope"
      class="button-facebook-connect d-inline-flex align-items-center py-1"
      @click="handleFbLogin(scope)"
    >
      <img
        draggable="false"
        src="@/assets/img/common/facebook.png"
        class="token"
      />
      <slot
        v-if="scope.disconnected || (scope.connected && !scope.working)"
        name="login"
        ><p class="facebook-connect-text">
          {{ $t("dailylogin.facebook_button") }}
        </p>
        <div class="d-inline-flex align-items-center justify-content-center">
          <span>+50.000</span>
          <BaseAsset asset="primary" class="ms-1" />
        </div>
      </slot>

      <slot v-else name="working">
        <div class="facebook-btn-text text-center">
          <p>{{ $t("login.web.facebook_button.waiting") }}</p>
        </div></slot
      >
    </button></VFBLoginScope
  >
</template>

<script>
import * as profileAPI from "@/API/profile.js";
import { VFBLoginScope } from "vue-facebook-login-component";
import BaseAsset from "./base-asset.vue";

export default {
  name: "FacebookConnectButton",
  components: { BaseAsset, VFBLoginScope },
  data() {
    return {
      facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
    };
  },
  computed: {},

  methods: {
    handleFbLogin(scope) {
      scope.login();
    },
    connectToFacebook(e) {
      if (e.status === "connected") {
        profileAPI
          .connectToFacebook(e.authResponse.accessToken)
          .then((res) => {
            this.$store.commit("user/updateUserObject", res.data.data.user);
            this.$emit("facebookConnectSuccess");
          })
          .catch((e) => {
            this.$emit("facebookConnectError");

            if (e.data.message) {
              if (e.data.id === "socialuser_already_on_different_user") {
                this.$store.commit("popups/setAlertBannerContent", {
                  alertHeading: this.$t("alerts.title.error"),
                  alertText: this.$t("error.fb_already_on_different_user"),
                  type: "danger",
                  variant: "danger",
                });
              } else {
                this.$store.commit("popups/setAlertBannerContent", {
                  alertHeading: this.$t("alerts.title.error"),
                  alertText: e.data.message,
                  type: "danger",
                  variant: "danger",
                });
              }
            } else {
              this.displayErrorMessage();
            }
          });
      } else {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped lang="scss">
#facebook-connect-button {
  width: 100%;
  .facebook-connect-text {
    margin: 0;
    line-height: 1;
    font-size: 12px;
  }
}
</style>
